import React from "react"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { classes } from "@utils"

export const ArticleParagraph = ({ content }) => {
  const { title, text, childContentfulArticleLeadLeadTextNode } = content
  const { aCB } = classes

  const filterRichText = (arr) =>
    arr.filter(
      (obj) =>
        obj.props.children[0] !== "" &&
        obj.props.children[0].props?.children[0] !== ""
    )

  if (childContentfulArticleLeadLeadTextNode)
    return (
      <div className={`${aCB}-lead`}>
        <h3>{childContentfulArticleLeadLeadTextNode.lead}</h3>
      </div>
    )

  return (
    <div className={`${aCB}-paragraph`}>
      <h4>{title}</h4>
      {text !== undefined && text !== null && (
        <div className={`${aCB}-paragraph__md`}>
          {filterRichText(renderRichText(text))}
        </div>
      )}
    </div>
  )
}
